export default "__VITE_ASSET__DF$KAV8T__"